<template>

	<div class="overlay" v-if="show">

		<p 
			:class="[{description:true},classes]" 
			v-html="this.settings.text" 
			@click="clicked()"
		/>

	</div>

</template>

<script>
export default {
  name: 'InfoPanelOverlay',
  props: {
  	settings: {
  		type: [Object,Boolean],
  		default: false
  	},
  },
  data() {
	return {
	  
	}
  },
  computed: {

  	show() {

  		return typeof this.settings === 'object' && Object.keys(this.settings).length > 0;

  	},
  	classes() {

  		let c = {};

  		if ( this.settings.click ) {

  			c.clickable = true;

  		}

  		return c;

  	}

  },
  methods: {

  	clicked() {

  		if ( this.settings.click ) {

  			this.$emit( 'overlayClicked' );

  		}

  	}

  }
}
</script>
<style lang="less" scoped>
@import './../assets/css/less/_helper.less';
.overlay {

    background-color:rgba(0,0,0,0.9);
    width: 100%;
    height: 100%;
    .vertical-align-parent;
    position:absolute;
    left: 0;
    top: 0;

    .description {

        .vertical-align;
        color: #fff;
        padding:0;
        margin:0 0 0 -100px;
        width: 200px;
        left: 50%;
        border: 1px solid #fff;
        padding: 20px;
		text-align: center;

        &.clickable {

        	cursor: pointer;

        }

    }

}
</style>